"use client";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import type { UserProgress } from "@/lib/gamification-shared";

export function ProgressHeader() {
  const [progress, setProgress] = useState<UserProgress | null>(null);
  const [readinessPct, setReadinessPct] = useState(0);

  useEffect(() => {
    fetch("/api/gamification/progress")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.progress) setProgress(data.progress);
        if (typeof data?.readinessPct === "number") setReadinessPct(data.readinessPct);
      })
      // intentional: read-only progress prefetch; missing data renders nothing (component returns null)
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handler = (e: CustomEvent<UserProgress>) => {
      setProgress(e.detail);
    };
    window.addEventListener("gamification:update", handler as EventListener);
    return () => window.removeEventListener("gamification:update", handler as EventListener);
  }, []);

  if (!progress) return null;

  return (
    <div className="relative h-1 w-full bg-white/[0.06] overflow-hidden">
      <motion.div
        className="absolute inset-y-0 left-0 bg-gradient-to-r from-amber-500 to-orange-500"
        initial={{ width: 0 }}
        animate={{ width: `${readinessPct}%` }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      />
    </div>
  );
}
